import axios from "axios";
import { API_URL } from "../config/axiosConfig";

export const apiCreateSahakari = (payload, token) =>
  axios.post(`${API_URL}/v1/users/sahakari/add`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetSahakari = (token) =>
  axios.get(`${API_URL}/v1/admins/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetSahakariMainBranch = (token) =>
  axios.get(`${API_URL}/v1/sahakari/mainBranch/list`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetSahakariById = (token, id) =>
  axios.get(`${API_URL}/v1/sahakari/id/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiDeleteSahakariById = (token, id) =>
  axios.delete(`${API_URL}/v1/sahakari/delete/id/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiUpdateSahakari = (token, payload) =>
  axios.put(`${API_URL}/v1/sahakari/update`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiAddSahakariCustomersCsv = (token, id, payload) =>
  axios.post(`${API_URL}/v1/customers/sahakariId/${id}/csvUpload`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetSahakariStats = (token) =>
  axios.get(`${API_URL}/v1/dashboard/admin`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetSahakariSubscriptionStatus = (token) =>
  axios.get(`${API_URL}/v1/sahakariSubscriptionStatus`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
